var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import Label from '../label/index.react';
import createStyle from './createStyle';
export var Textarea = function Textarea(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.value,
      value = _c === void 0 ? '' : _c,
      forwardedRef = _a.forwardedRef,
      _d = _a.label,
      label = _d === void 0 ? '' : _d,
      _e = _a.theme,
      theme = _e === void 0 ? 'light' : _e,
      _f = _a.disabled,
      disabled = _f === void 0 ? false : _f,
      props = __rest(_a, ["className", "value", "forwardedRef", "label", "theme", "disabled"]);

  var finalClassName = createStyle({
    className: className,
    disabled: disabled
  });
  return React.createElement(React.Fragment, null, typeof label === 'string' && label.length > 0 ? React.createElement(Label, {
    disabled: disabled,
    theme: theme,
    htmlFor: props.id
  }, label) : label, React.createElement("textarea", __assign({
    ref: forwardedRef,
    className: finalClassName,
    value: value
  }, props)));
};
export default React.forwardRef(function (props, forwardedRef) {
  return React.createElement(Textarea, __assign({}, props, {
    forwardedRef: forwardedRef
  }));
});